import { useMutation } from '@tanstack/react-query';
import { updateRelationshipReferences } from 'shared/services/backend-api';
import { MinimalRelationship } from 'shared/types/relationship';

export const useUpdateRelationshipsReferencesMutation = () =>
  useMutation({
    mutationFn: (relationships: MinimalRelationship[]) =>
      updateRelationshipReferences(relationships),
  });
